
import { Info } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface FormHelpTextProps {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  tooltipText?: string;
}

const FormHelpText = ({ 
  children, 
  className, 
  showIcon = true,
  tooltipText
}: FormHelpTextProps) => {
  if (tooltipText) {
    return (
      <TooltipProvider>
        <div className={cn("flex items-start gap-1 text-sm text-gray-500", className)}>
          {showIcon && <Info className="h-4 w-4 text-propertylk-blue shrink-0 mt-0.5" />}
          <span>{children}</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="h-4 w-4 text-propertylk-blue cursor-help ml-1 shrink-0 mt-0.5" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p>{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </div>
      </TooltipProvider>
    );
  }

  return (
    <div className={cn("flex items-start gap-1 text-sm text-gray-500", className)}>
      {showIcon && <Info className="h-4 w-4 text-propertylk-blue shrink-0 mt-0.5" />}
      <span>{children}</span>
    </div>
  );
};

export default FormHelpText;
